var map = {
	"./3.04-1.PNG": 765,
	"./3.4.1-21.png": 861,
	"./3.4.2-1.PNG": 8445,
	"./3.4.2-3.PNG": 5807,
	"./511.webp": 2362,
	"./512.webp": 2811,
	"./521.webp": 7433,
	"./522.webp": 3068,
	"./APITestings.png": 4294,
	"./AuditHistory.png": 9914,
	"./AutomationActions.png": 8187,
	"./CapabilityGenerator.png": 5152,
	"./DefectManagement.png": 4007,
	"./ExportAudit.png": 850,
	"./ExportAuditTT.png": 5426,
	"./Flexiblereport.png": 7222,
	"./Generationof.png": 616,
	"./GitHub.png": 7060,
	"./MediaUpload.jpg": 4894,
	"./MediaUpload1.png": 8585,
	"./MediaUpload2.jpg": 3446,
	"./Notificationchanges.png": 6685,
	"./PersonalAPIToken.png": 7270,
	"./Quick.PNG": 2783,
	"./Quickl.PNG": 4115,
	"./Ration.PNG": 7553,
	"./Removed PDF and DOC formats 3.4.PNG": 4692,
	"./Scheduler.png": 5394,
	"./Test-Cycle-version-8.png": 8472,
	"./TestCyclev5.png": 4620,
	"./Testing.PNG": 3346,
	"./Title.png": 4099,
	"./agent_os.png": 7497,
	"./api-new-feature.png": 7861,
	"./api-new-feature2.png": 7203,
	"./apiTestingsss.png": 884,
	"./automation-execution.png": 8797,
	"./availableLicenses.png": 396,
	"./bulkapproval.png": 4008,
	"./created_date_project.png": 4992,
	"./customseven.png": 5649,
	"./cycle_api.png": 7398,
	"./defect.png": 8854,
	"./enforcing 2-5 character.PNG": 6648,
	"./filter.png": 603,
	"./frothai_1.png": 9016,
	"./frothai_2.png": 2227,
	"./planeandgit.png": 5502,
	"./precondition-linking.png": 716,
	"./precondition-pagination.png": 9002,
	"./profiledetails.jpg": 9438,
	"./profiledetails1.png": 9801,
	"./project-audit.png": 4448,
	"./project.png": 5606,
	"./projects.png": 9071,
	"./projectshortcode.png": 4177,
	"./puzzle.png": 7253,
	"./quick-edit.png": 1403,
	"./quickactions.png": 2291,
	"./reports.png": 5020,
	"./seamless.png": 6096,
	"./selectall_reports.png": 6212,
	"./setting-users.png": 7218,
	"./smarter-test-cycle.png": 4399,
	"./suite_api.png": 9532,
	"./syntaxvalidator.png": 8516,
	"./test-cycle.png": 708,
	"./testcase.png": 2581,
	"./testcycle.png": 299,
	"./testlab.png": 9316,
	"./testlab_agent.png": 3450,
	"./testmanagement.png": 8324,
	"./testplan_download.png": 3241,
	"./testplan_request.png": 8962,
	"./testplan_signoff.png": 363,
	"./uploadmedia_integration.png": 4963,
	"./user.png": 8448,
	"./v-8.3-Browserstack.png": 4044,
	"./v-8.3-Notifications.png": 6722,
	"./v-8.3-Sort functionalitys.png": 9178,
	"./v-8.3-custom field.png": 7781,
	"./ver9-Execution.png": 6516,
	"./ver9-multi-attachemnts.png": 4624,
	"./ver9-multi.png": 3053,
	"./ver9-notifications.png": 8974,
	"./ver9-scheduler.png": 845,
	"./version-10-Dashboards.png": 9573,
	"./version-10-Features.png": 7999,
	"./version-10-Requirement.png": 2353,
	"./version-10-Targets.png": 9670,
	"./version-10-Test-Automation.png": 9816,
	"./version-10-analysis.png": 3116,
	"./version-10.1-buildname.png": 2013,
	"./version-10.1-capability.png": 5313,
	"./version-10.1-custom field.png": 8410,
	"./version-10.1-dashboard.png": 3919,
	"./version-10.1-filter.png": 6437,
	"./version-11-Custom-Fields.png": 8900,
	"./version-11-Reports.png": 4764,
	"./version-11-Security.png": 5067,
	"./version-11-dashboard.png": 4473,
	"./version-11-execution.png": 7311,
	"./version-11-load.png": 5857,
	"./version-11-script.png": 7604,
	"./version-11.1-AI.png": 5410,
	"./version-11.1-Manual-Execution.png": 9799,
	"./version-11.1-Requirement.png": 8071,
	"./version-11.1-Scan.png": 6103,
	"./version-11.1-Settings.png": 4311,
	"./version-11.1-target.png": 6311,
	"./version-11.1-target2.png": 7973,
	"./version-11.2-1.1.png": 5031,
	"./version-11.2-1.2.png": 204,
	"./version-11.2-1.3.png": 3093,
	"./version-11.2-1.4.png": 5146,
	"./version-11.2-2.1.png": 2728,
	"./version-11.2-2.3.png": 6458,
	"./version-11.2-2.4.png": 1125,
	"./version-12.1-1.png": 76,
	"./version-12.1-2.png": 4903,
	"./version-12.2-3.png": 1277,
	"./version-13.1-1.png": 9381,
	"./version-13.2-1.png": 8342,
	"./version-13.2-2.png": 5901,
	"./version-13.2-3.png": 2868,
	"./version-13.2-4.png": 2779,
	"./version-14.1-1.png": 1862,
	"./version-14.1-2.png": 8893,
	"./version-14.2-1.png": 2469,
	"./version-14.2-2.png": 2110,
	"./version-14.3-1.png": 1992,
	"./version-15.1-1.png": 6535,
	"./version-15.1-2.png": 7804,
	"./version-15.1-3.png": 5317,
	"./version-15.2-1.png": 516,
	"./version-16.1-1.png": 5656,
	"./version-16.1-1s.png": 3249,
	"./version-16.1-2.png": 7635,
	"./version-16.1-2s.png": 1584,
	"./version-16.1-3.png": 7802,
	"./version-16.1-3s.png": 9483,
	"./version-16.1-5.png": 8236,
	"./version-16.1-5s.png": 2781,
	"./version-16.1-6.png": 5271,
	"./version-16.1-7.png": 9486,
	"./version-16.1-7s.png": 1095,
	"./version-16.1-8.png": 8889,
	"./version-17.1-1.png": 2993,
	"./version-17.1-2.png": 1882,
	"./version-18-1.png": 7097,
	"./version-18-2.png": 6386,
	"./version-7.png": 289,
	"./version-8-gitlab.png": 1372,
	"./version-8-jira.png": 9445,
	"./version-Requirements-8.png": 9383,
	"./version5.png": 9868,
	"./version8-media.png": 1406,
	"./version8-requirement.png": 9391,
	"./version8.2-Integration.png": 1024,
	"./version8.2-Test-Lab.png": 8938,
	"./version8.2-report.png": 5430,
	"./versionse.png": 8413
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6917;